import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const Zendesk: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  return (
    <Helmet>
      <script
        id="ze-snippet"
        src={`https://static.zdassets.com/ekr/snippet.js?key=${accountId}`}
      ></script>
    </Helmet>
  );
};

export default Zendesk;
